export default {
lang: 'jp',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav": 'VORMOR AI',
		"nav2": 'アカウントのセキュリティ',
		"nav3": '私のクラウドディスク',
		"nav4": 'ログアウト',
		"nav5": 'ログイン',
		"nav6": 'クラウドスペース',
		"nav7": 'ChatGPT AI ボイスレコーダー',
		"nav8": 'クラウドスペースシステム',
	},
	login: {
		"login1": 'パスワードログイン',
		"login2": 'SMS ログイン',
		"loginTab3": 'メールログイン',
		"login3": 'メールアドレス',
		"login4": 'ログインパスワード',
		"login5": '携帯電話番号',
		"login6": '選択してください',
		"login7": '携帯電話認証コード',
		"login8": 'ログイン',
		"login9": 'パスワードを忘れた場合',
		"login10": '登録',
		"login11": 'ログインすると同意したことになります',
		"login12": 'サービス契約',
		"login13": 'プライバシー同意書',
		"login14": '取得',
		"login15": '中国',
		"login16": 'アカウント番号を入力してください',
		"login17": 'パスワードを入力してください',
		"login18": 'ログイン成功!',
		"login19": '確認コードを入力してください!',
		"login20": '正常に送信されました!',
		"login21": 'および',

		"login22": 'クラウドスペース',
		"login23": '私の書き込み',
		"login24": '私の会話',
		"login25": 'アカウントのセキュリティ',
		"login26": 'ログアウト',



		"login27": '電子メールでパスワードを取得',
		"login28": 'メールアドレス',
		"login29": 'メール認証コード',
		"login30": 'ログインパスワードを設定します(6～16文字)',
		"login31": 'ログインパスワードを再度入力してください',
		"login32": '送信',
		"login33": 'ログインに戻る',
		"login34": '変更は成功しました!',
	},
	register: {
		"register1": '携帯電話番号',
		"register2": '携帯電話番号を入力してください',
		"register3": '選択してください',
		"register4": '携帯電話認証コード',
		"register5": 'パスワードを設定',
		"register6": '確認コードを入力してください',
		"register7": '6 ～ 16 文字',
		"register8": 'パスワードの確認',
		"register9": 'メールボックス',
		"register10": 'メールアドレスを入力してください',
		"register11": 'メール認証コード',
		"register12": '確認コードを入力してください',
		"register13": '読んで同意します',
		"register14": '同意する場合は、読んでボックスにチェックを入れてください',
		"register15": '携帯電話番号の形式が間違っています/携帯電話番号が登録されています',
		"register16": '携帯電話認証コードエラー',
		"register17": 'メールアドレスを入力してください/メール形式が間違っています',
		"register18": 'メール形式エラー',
		"register19": 'メール認証コードエラー',
		"register20": '6～16文字のパスワードを設定してください',
		"register21": 'パスワード形式エラー',
		"register22": '2 回入力したパスワードは一致しません。再入力してください',
		"register23": 'パスワードを入力してください',
		"register24": '登録に成功しました!',
		"register25": '認証コードエラー',
	},
	recorder:{
		"recorder1":'クラウドスペース',
		"recorder2":'クラウドスペース容量',
		"recorder3":'ファイル',
		"recorder331":'ごみ箱',
		"recorder332":'すべて削除',
		"recorder4":'名前',
		"recorder5":'音声の長さ',
		"recorder6":'ファイルサイズ',
		"recorder7":'作成時間',
		"recorder8":'操作',
		"recorder9":'クラウドスペースの説明',
		"recorder10":'ファイル',
		"recorder11":'OCR ファイル',
		"recorder12":'1.クラウド空間用途',
		"recorder13":'スマートオフィスブック、録音ペンに録音、手書きメモを保存した後、スマートデバイスが手元になくても、クラウドスペースに入ってメモファイルを見ることができます。',
		"recorder14":'2.クラウド空間をアップロードする方法',
		"recorder15":'録音ペン：デバイス【マイファイル】に入る→一括操作をクリック→「アップロード」をクリックすると、ファイルをクラウドアップロードキューに追加し、クラウド空間にアップロードすることができます。',
		"recorder16":'スマートオフィスブック：',
		"recorder17":'方法一：メモリストを長押しし、アップロードするメモを一括選択する→「同期」をクリックしてアップロードを完了する、',
		"recorder171":'方法2：メモ詳細ページを開く→【詳細-同期】をクリックすると、メモをクラウド空間にアップロードできます。',

		"recorder18":'転写されません',
		"recorder19":'概要を表示',
		"recorder20":'スピーカー',
		"recorder21":'スピーカー名を編集',
		"recorder22":'OK',
		"recorder23":'ダウンロード',
		"recorder24":'ダウンロードコンテンツ:',
		"recorder25":'ダウンロード設定:',
		"recorder26":'スピーカーを表示',
		"recorder27":'キャンセル',
		"recorder28":'リンク共有',
		"recorder29":'リンクを知っている人は誰でもアクセスできます。読み取りのみがサポートされています。リンクは 7 日間有効です',
		"recorder30":'リンクをコピー',
		"recorder31":'スキャンしてすぐに表示',
		"recorder32":'インテリジェントな並べ替え',
		"recorder33":'スピーカーを区別する',
		"recorder34":'話者の役割に応じて、書き起こされたテキストをインテリジェントに区別します',
		"recorder35":'インテリジェントな話し言葉の正規化',
		"recorder36":'モーダル助詞、繰り返される単語、一時停止単語を自動的にフィルターします',
		"recorder37":'非ボーカルフィルター',
		"recorder38":'再生中に音やノイズが発生せずにオーディオを自動的にスキップします',
		"recorder39":'選択してください',
		"recorder40":'ドキュメント',
		"recorder41":'オーディオ',
		"recorder42":'ドキュメント+オーディオ',

		"recorder43":'プロンプト',
		"recorder44":'この操作ではファイルが削除されます。続行しますか?',
		"recorder441":'この操作ではすべてのファイルが削除されます。続行しますか?',
		"recorder45":'OK',
		"recorder46":'キャンセル',
		"recorder47":'削除に成功しました!',
		"recorder48":'削除がキャンセルされました',
		"recorder49":'まだマークがありません',
		"recorder50":"保存中...",
		"recorder51":'ごみ箱',
	},
	personal: {
		"personal1": 'アカウント設定',
		"personal2": '個人情報',
		"personal3": 'アバター',
		"personal4": 'ファイルをアップロード',
		"personal5": 'JPG、JPEG、GIF、PNG スタイルをサポートし、2M 以内の画像をサポート',
		"personal6": 'ニックネーム',
		"personal7": 'ニックネームを入力してください',
		"personal8": '性別',
		"personal9": 'さん',
		"personal10": 'さん',
		"personal11": '機密',

		"personal12": '誕生日',
		"personal13": '誕生日を選択してください',
		"personal14": 'キャリア',
		"personal15": '職業を選択してください',
		"personal16": '職業を入力してください (必須ではありません)',
		"personal17": '国',
		"personal18": '国を選択してください',
		"personal19": '保存',
		"personal20": '個人情報',
		"personal21": 'アカウントのセキュリティ',
		"personal22": '2M 以内の画像のみをサポートします',
		"personal23": 'アップロード成功!',
		"personal24": '変更が成功しました!',

		"personal25": 'アカウントのセキュリティ',
		"personal26": 'ログインパスワード',
		"personal27": '変更',
		"personal28": '電子メール',
		"personal29": '置換',
		"personal30": 'アカウントのログアウト',
		"personal32": 'アカウントをキャンセルしてもよろしいですか? ',
		"personal33": 'ログアウトすると、アカウントのすべてのコンテンツが消去されます。注意して続行してください。 ',
		"personal34": 'キャンセル',
		"personal35": 'OK',
		"personal36": '認証',
		"personal37": 'ご本人であることを確認するには、電子メール確認コードを使用して本人確認を完了してください',
		"personal38": '電子メール',
		"personal39": '認証コード',
		"personal40": '確認コードを入力してください',
		"personal41": '次のステップ',
		"personal42": '新しいメールアドレスを設定',
		"personal43": '電子メール',
		"personal44": '新しいメールアドレスを入力してください',
		"personal45": '認証コード',
		"personal46": '確認コードを入力してください',
		"personal47": 'OK',
		"personal48": '新しいログインパスワードを設定します',
		"personal49": '新しいログインパスワード',
		"personal50": '新しいパスワードを入力してください',
		"personal51": '新しいパスワードを確認します',
		"personal52": '新しいパスワードをもう一度入力してください',
		"personal53": 'OK',
		"personal54": '取得',

		"personal55": 'メール形式エラー',
		"personal56": '置換に成功しました!',
		"personal57": '6 ～ 16 文字のパスワードを設定してください',
		"personal58": '2 回入力したパスワードは一致しません',
		"personal59": '変更は成功しました!',
		"personal60": 'ログアウト成功!',
		"share_url": "リンク共有",
		"share_url_7_day": "共有リンクは7日間有効です。有効期限が切れるまでは、リンクを受け取った人は誰でもアクセスできます。",
		"share_audio": "音声録音",
		"share_trans_text": "文字起こし",
		"share_summny_text": "概要",
		"share_map": "マインドマップ",
		"share_url_pw": "アクセス暗号化",
		"share_random_pw": "パスワードはランダムに生成されました",
		"share_url_copy": "リンクをコピー",
		"share_url_copy_success": "リンクのコピーに成功しました",
		"share_link_pw": "アクセスパスワード",
		"share_copy_success": "転写がクリップボードにコピーされました!",
		"share_copy_success2": "クリップボードに要約をコピーしました!",
		"share_speaker": "スピーカー",
		"share_no_update_speaker": "スピーカーが空のため編集できません",
		"share_no_trans":"文字起こしテキストがありません",
		"share_no_summny":"概要がありませんテキスト",
		"share_no_map":"マップコンテンツがありません",
		"share_trans_text_1": "転写",
		"share_summny_text_1": "概要",
		"share_map_1": "地図",
		"share_save": "保存に成功しました",
		"share_no_map":"マップ画像が生成されませんでした",
		"share_update_text2": "概要テキストを編集",
		"showLoading": "読み込み中...",
		"handwriting": "手書きコンテンツ",
		"handwritingText": "手書き",
		"share_1": "このページの手書きコンテンツは認識されません",
		"share_2": "手書き認識を編集",
		"share_3": "手書き認識",
		"share_4":"ファイルをエクスポートしています。このページから出ないでください",
		"folder_text":"フォルダ",
		"folder_text_update_name":"名前を変更",
		"folder_text_del":"削除",
		"folder_text_all":"すべて",
		"folder_text_type":"ファイルの種類",
		"folder_text_audio":"音声メモ",
		"folder_text_writing":"手書きメモ",
		"folder_text_file_type":"ファイルの種類",
		"folder_text_add":"新しいフォルダを作成",
		"folder_text_input_name":"名前を入力してください",
		"folder_text_cancel":"キャンセル",
		"folder_text_summit":"確認",
		"folder_text_name_not_null":"名前は空欄にできません",
		"folder_text_add_success":"作成に成功しました！",
		"folder_text_del_confirm":"削除を確認しました",
		"folder_text_confirm":"選択したフォルダを削除してもよろしいですか？削除後、フォルダ内のメモはごみ箱に移動されます。",
		"folder_text_del_success":"削除に成功しました！",
		"folder_text_move":"移動しました。",
		"folder_text_move_success":"移動に成功しました！",
		"folder_update_name":"フォルダ名を変更しました。",
		"folder_text_update_success":"変更に成功しました！",
		"empty_text":"利用可能なデータはありません。",
		"trans_text_null":"転記テキストは空欄にできません。",
		"summary_text_null":"要約は空欄にできません。",
		"please_create_folder":"まずフォルダを作成してください"
	}
}